import { Pill, Stack, Tooltip, TooltipContent, TooltipTrigger } from 'component-library';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const PendingApprovalFrame = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();

  return (
    <Stack className='border-2 border-dashed border-[#F57D27] rounded-lg p-2' spacing={4}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Pill
            className='typography-overline font-bold w-fit rounded px-[9px] py-2 m-auto'
            style={{
              color: '#000000',
              backgroundColor: '#FFD700',
            }}
            leftAdornment={<i className='ri-time-line' />}
          >
            {t('global.misc.pendingApproval')}
          </Pill>
        </TooltipTrigger>
        <TooltipContent className='whitespace-pre-wrap'>
          <Stack>{t('global.misc.pendingApprovalTooltip')}</Stack>
        </TooltipContent>
      </Tooltip>

      {children}
    </Stack>
  );
};
